import { moveType } from '../moveType';

export class MovementData {
    constructor() {
        this.layers = [];
        this.mask = [];
    }

    /**
     * All added layers must be the same size.
     *
     * @param {Object} layer
     */
    addLayer(layer) {
        // Init mask to 0.
        if (this.mask.length <= 0) {
            this.mask = Array(layer.data.length).fill(0);
        }

        for (let i = 0; i < layer.data.length; i++) {
            if (layer.data[i] > 0) this.mask[i] = 1;
        }

        this.layers.push(layer);
    }

    /*
    rebuildMovementMask() {
        let layer;
        for (let i = 0; i < this.layers.length; i++) {
            layer = this.layers[i];
            for (let j = 0; j < layer.data.length; j++) {

            }
        }
    }
    */

    hasMoveType(index, type) {
        for (let i = this.layers.length - 1; i >= 0; i--) {
            if (this.layers[i].data[index] == type) return true;
        }

        return false;
    }

    getMoveTypes(index) {
        let data = [];

        for (let i = this.layers.length - 1; i >= 0; i--) {
            if (this.layers[i].data[index] > 0) data.push(this.layers[i].data[index]);
        }

        return data;
    }
}
